import apiClient from '@u/apiClient'

export default {
  //region Fetch
  async fetchAccountingCodeList({ commit }) {
    await apiClient
      .get('api/accountingCode')
      .then(async (response) => {
        commit('setAccountingCodeList', response.data.accounting_codes)
      })
      .catch(async (reason) => {
        console.error('fetchAccountingCodeList', reason)
      })
  },

  //endregion

  //region store
  storeAccountingCode({ commit }, payload) {
    return apiClient
      .post('api/accountingCode', payload.accountingCode)
      .then(async (response) => {
        commit('setAccountingCodeList', response.data.accounting_codes)
        return response.data
      })
  }
  //endregion
}
